import React from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { COLORS} from "../constant";
import CText from "./CText";
import CView from "../common/CView";

const styles = {
  applyLoanTab: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 26,
    borderRadius: 15,
    borderStyle: "solid",
    borderColor: COLORS.boderColor,
    backgroundColor: COLORS.whiteTwo,
    width: 270,
    height: 80,
    borderWidth: 1,
    boxShadow: "0 11px 17px 0 rgba(176, 176, 176, 0.18)",
  },

  statusBlockWrapper: {
    backgroundColor: COLORS.lightGrayOp20,
    width: 386.8,
    maxHeight: 165,
    borderRadius: 10,
    paddingTop: 15,
  },
  statusBlockWrapper1: {
    backgroundColor: COLORS.white,
    width: 330.8,
    height: 107,
    borderRadius: 10,
    paddingTop: 25,
    marginTop: 10,
    shadowColor: "rgba(0, 0, 0, 0.13)",
    shadowOffset: {
      width: 0,
      height: 0.4,
    },
    shadowRadius: 9,
    shadowOpacity: 1,
  },
  statusContent: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingHorizontal: 100,
    marginTop: 10,
  },
  statusContent1: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingHorizontal: 20,
    flex: 1,
  },
  serviceImageStyle: { width: 41, height: 41 },
  arrowImageStyle: { width: 10.6, height: 10.2 },
};
const applyLoanTab = React.memo((props) => (
  <TouchableOpacity
    style={styles.applyLoanTab}
    onPress={() => props.onPress(props.navigation)}
  >
    <Image source={props.img} style={props.style}></Image>
    <Text>{props.text}</Text>
    <Image source={props.img2} style={styles.arrowImageStyle}></Image>
  </TouchableOpacity>
));
const trackStatusCard = (props) => (
  <TouchableOpacity
    style={{ ...styles.statusBlockWrapper1, ...props.styles }}
    onPress={() => props.onPress(props.navigation)}
  >
    <View style={styles.statusContent1}>
      <View style={{ flex: 1 }}>
        <CText.inputTopLabel>{props.key1}</CText.inputTopLabel>
      </View>

      <View style={{ flex: 1 }}>
        <CText.inputTopLabel>: {props.value1}</CText.inputTopLabel>
      </View>
    </View>
    <View style={styles.statusContent1}>
      <CText.inputTopLabel style={{ color: "orange" }}>
        {"Click here to get the status"}
      </CText.inputTopLabel>
    </View>
    
    <Image source={props.img2} style={styles.arrowImageStyle}></Image>
    <View style={styles.statusContent1}>
      <View style={{ flex: 1 }}>
        <CText.inputTopLabel>{props.subTitle}</CText.inputTopLabel>
      </View>
    </View>
  </TouchableOpacity>
);
const validateButton = (props) => (
  <TouchableOpacity onPress={props.onPress}></TouchableOpacity>
);
const statusBlock = (props) => (
  <View style={{ ...styles.statusBlockWrapper, ...props.styles }}>
    <View style={{ ...styles.statusContent, ...props.contentStyles }}>
      <View style={{ flex: 1 }}>
        <CText.inputTopLabel>Application ID</CText.inputTopLabel>
      </View>

      <View style={{ flex: 1 }}>
        <CText.inputTopLabel>: {props.data.applicationId}</CText.inputTopLabel>
      </View>
    </View>
    <View style={{ ...styles.statusContent, ...props.contentStyles }}>
      <View style={{ flex: 1 }}>
        <CText.inputTopLabel>Status</CText.inputTopLabel>
      </View>

      <View style={{ flex: 1 }}>
        <CText.inputTopLabel>: {props.data.status}</CText.inputTopLabel>
      </View>
    </View>
    <View
      style={{
        alignItems: "center",
        justifyContent: "center",
        paddingHorizontal: 10,
        paddingBottom: 10,
        marginTop: 10,
      }}
    >
      <CText.inputTopLabel style={{ textAlign: "center" }}>
        {" "}
        {props.data.secondaryStatus}
      </CText.inputTopLabel>
    </View>
  </View>
);

const mobileDescTextView = (props) => (
  <CView FR AS JC GAP={10}>
    <View
      style={{
        height: 5,
        width: 5,
        borderRadius: 2.5,
        backgroundColor: "#66625f",
        marginTop: 5,
      }}
    />
    <CText.mobileDescText>
      {props.text}
      
    </CText.mobileDescText>
  </CView>
);

const services = (props) => {
  <View>
    <Image source={props.image} style={styles.serviceImageStyle} />
    <CText.serviceDesc>{props.text}</CText.serviceDesc>
  </View>;
};
export default { applyLoanTab, statusBlock, services, trackStatusCard,mobileDescTextView };
